// Browser-side Sentry init.
//
// `@sentry/astro` finds this file by name and injects an import of it into every
// page, so nothing imports it explicitly. Errors only: no Replay integration is
// added, and `bundleSizeOptimizations` in `astro.config.mjs` compiles the
// tracing and Replay code out of the chunk rather than merely leaving it unused.
//
// The environment name has to be baked in at build time, so it comes from
// `PUBLIC_SENTRY_ENVIRONMENT` (a `PUBLIC_` variable is the only kind Astro
// exposes to the browser). The deploy workflow sets it per environment; a local
// build leaves it unset and `sentryEnvironment` falls back to `development`.

import * as Sentry from "@sentry/astro";
import { sentryInitOptions } from "./src/lib/sentry";

Sentry.init(sentryInitOptions(import.meta.env.PUBLIC_SENTRY_ENVIRONMENT));
